// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer[data-v-d0ea8268]{background-color:#3b3b3e;width:100%;text-align:center;margin-top:30px;padding:10px 0}.footer-copyright[data-v-d0ea8268]{margin:0 auto;width:100%}.footer-copyright>p[data-v-d0ea8268]{font-size:12px;line-height:17px;color:#b8b8b8}", ""]);
// Exports
module.exports = exports;
